// // src/theme.ts
// import { createTheme } from '@mui/material/styles';

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: '#c8e6c9',
//     },
//     secondary: {
//       main: '#ffe0b2',
//     },
//     background: {
//       default: '#fffdd0'
//     }
//   },
// });

// export default theme;

// src/theme.ts
import { createTheme , responsiveFontSizes } from '@mui/material/styles';

let theme = createTheme({
  typography: {
    fontFamily: [
      'sans-serif',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
    ].join(','),
    h1: {
      fontSize: '2.5rem',
      fontWeight: 'bold',
    },
    h2: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
    },
    h3: {
      fontSize: '2rem',
      fontWeight: 'bold',
    },
    h4: {
      fontSize: '1.75rem',
      fontWeight: 'bold',
    },
    h5: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
    },
    h6: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
    },
    body1: {
      fontSize: '0.9rem',
      // fontWeight: 'bold',
    },
    body2: {
      fontSize: '0.82rem',
      // fontWeight: 'bold',
    },
  },
  palette: {
    primary: {
      light: '#c8e6c9', // Light green
      main: '#2c7a7b', // medium teal
      dark: '#003333', // dark teal
    },
    secondary: {
      // main: '#ffe0b2', // Light orange
      // main: '#ff6060',
      // main: '#ff7062',
      // main: '#ff580f'
      // main: '#FF8048'
      light: '#FFA57D', // light coral
      main: '#ff6060', // rose coral
      dark: '#f55f51', // dark orange
    },
    background: {
      default: '#fffde7', //cream
    },
  },
});

// Enable responsive typography
theme = responsiveFontSizes(theme);

export default theme;
